import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom/cjs/react-router-dom.min";
import { ToastContainer, toast } from "react-toastify";
import TopHeader from "./TopHeader";
import LeftSidebar from "./LeftSidebar";
import { thirdparty } from "../..";
import { IMAGE_URL } from "../../constants";
import Pagination from "react-js-pagination";
const MediaUpload = () => {
  const [formData, setFormData] = useState(null);
  const [mediaList, setMediaList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(8); // Number of items to display per page

  // Fetch media data
  const fetchData = async () => {
    try {
      const response = await thirdparty.get("/media");
      if (response.status === 200) {
        setMediaList(response.data); // Assuming this contains the list of media
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect(() => {
    fetchData(); // Fetch media on component mount
  }, []);

  // Handle media file selection
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData(file);
  };

  // Handle media submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = new FormData();
    form.append("file", formData);

    try {
      const response = await thirdparty.post("/media/upload", form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.status === 200) {
        toast.success("Media uploaded successfully!", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        fetchData(); // Fetch updated list after upload
      }
    } catch (error) {
      console.error("Error uploading media:", error.message);
    }
  };

  // Handle media URL copy to clipboard
  const handleCopyURL = (mediaName) => {
    const mediaURL = `${IMAGE_URL}${mediaName}`;
    navigator.clipboard.writeText(mediaURL).then(
      () => {
        toast.success("URL copied to clipboard!", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
      },
      (err) => {
        toast.error("Failed to copy URL!", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
      }
    );
  };
  // Handle media URL copy to clipboard
  const handleCopyFilePath = (mediaName) => {
    const mediaURL = `${mediaName}`;
    navigator.clipboard.writeText(mediaURL).then(
      () => {
        toast.success("File path copied to clipboard!", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
      },
      (err) => {
        toast.error("Failed to copy File path!", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
      }
    );
  };

  // Handle media deletion
  const handleDelete = async (mediaId) => {
    try {
      const response = await thirdparty.delete(`/media/${mediaId}`);
      if (response.status === 200) {
        toast.success("Media deleted successfully!", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        fetchData(); // Fetch updated list after deletion
      }
    } catch (error) {
      console.error("Error deleting media:", error.message);
    }
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = mediaList.slice(indexOfFirstItem, indexOfLastItem);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="fixed-left">
      <div id="wrapper">
        <Route component={LeftSidebar} />
        <div className="content-page">
          <div className="content">
            <Route component={TopHeader} />
            <div className="page-content-wrapper">
              <div className="container">
                <h3>Media Upload</h3>
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="uploadFile" className="form-label">
                      Select Media
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      id="uploadFile"
                      onChange={handleFileChange}
                    />
                  </div>
                  <button type="submit" className="btn btn-primary">
                    Upload
                  </button>
                </form>

                <div className="mt-4">
                  <h4>Uploaded Media</h4>
                  <div className="row">
                    {currentItems.map((media) => (
                      <div
                        className="col-12 col-md-6 col-lg-4 mb-3"
                        key={media.id}
                      >
                        <div className="card h-100 d-flex flex-column justify-content-between">
                          <div className="">
                            {media.file_type === "application/pdf" ? (
                              <iframe
                                src={IMAGE_URL + media.file_path}
                                // src="https://docs.google.com/gview?url=https://path.com/to/your/pdf.pdf&embedded=true"
                                style={{ maxWidth: "350px", height: "250px" }}
                                frameborder="0"
                              ></iframe>
                            ) : (
                              <img
                                src={IMAGE_URL + media.file_path}
                                alt={media.name}
                                style={{
                                  maxWidth: "350px",
                                  height: "250px",
                                  objectFit: "cover",
                                  objectPosition: "center",
                                }}
                                className="card-img-top"
                              />
                            )}
                          </div>

                          <div className="card-body d-flex flex-column">
                            <strong className="card-title">
                              File Name: {media.title}
                            </strong>
                            <div className="d-flex gap-2">
                              <button
                                className="btn btn-outline-primary"
                                onClick={() => handleCopyURL(media.file_path)}
                              >
                                Copy URL
                              </button>
                              <button
                                className="btn btn-outline-primary"
                                onClick={() =>
                                  handleCopyFilePath(media.file_path)
                                }
                              >
                                Copy File path
                              </button>
                              <button
                                className="btn btn-outline-danger"
                                onClick={() => handleDelete(media.id)}
                              >
                                Delete
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Pagination */}
                  <Pagination
                    activePage={currentPage}
                    itemsCountPerPage={itemsPerPage}
                    totalItemsCount={mediaList.length}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default MediaUpload;



// WEBPACK FOOTER //
// ./src/component/admin/MediaUpload.js